module.exports = __webpack_public_path__ + "static/viaccessOrca-color-f9216fcef9b1dfd39238fbff97356510.png";